import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toBanglaNumber, formatCurrency } from '../../lib/utils';
import { KioskScreen } from '../../components/kiosk/KioskScreen';
const TICKET_PRICE = 20;
const QUANTITIES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20];
export function KioskHome() {
  const navigate = useNavigate();
  const handleSelect = (quantity: number) => {
    navigate('/payment', {
      state: {
        quantity,
        price: TICKET_PRICE
      }
    });
  };
  return <KioskScreen fullHeader data-id="element-474">
      {/* Compact Title Block */}
      <div className="px-6 pt-4 pb-3 text-center shrink-0" data-id="element-475">
        <p className="text-xs md:text-sm font-semibold tracking-widest uppercase text-emerald-800 mb-1" data-id="element-476">
          চিম্বুক পাহাড় টিকিটিং সিস্টেম
        </p>
        <h1 className="text-2xl md:text-4xl font-bold text-slate-900 leading-tight" data-id="element-477">
          চিম্বুক পাহাড়ে স্বাগতম
        </h1>
        <p className="text-base md:text-lg text-slate-700 font-medium mt-0.5" data-id="element-478">
          অনুগ্রহ করে টিকিট সংখ্যা নির্বাচন করুন
        </p>
      </div>

      {/* Ticket Cards Grid — fills remaining space */}
      <main className="flex-1 min-h-0 px-4 md:px-8 pb-2" data-id="element-479">
        <div className="h-full max-w-6xl mx-auto" data-id="element-480">
          <div className="h-full grid grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 auto-rows-fr" data-id="element-481">
            {QUANTITIES.map(qty => <button key={qty} onClick={() => handleSelect(qty)} className="group relative overflow-hidden rounded-2xl bg-white/95 backdrop-blur-md shadow-md border border-white/80 hover:bg-white hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] transition-all duration-150 flex flex-col items-center justify-center px-2 py-2" data-id="element-482">
                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-emerald-500 to-emerald-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-483" />
                <span className="text-3xl md:text-5xl font-bold text-slate-900 leading-none" data-id="element-484">
                  {toBanglaNumber(qty)}
                </span>
                <span className="text-xs md:text-sm text-slate-500 font-medium mt-1" data-id="element-485">
                  টিকিট
                </span>
                <div className="mt-1.5 px-3 py-0.5 rounded-full bg-emerald-50 group-hover:bg-emerald-100 transition-colors" data-id="element-486">
                  <span className="text-sm md:text-base font-bold text-emerald-700" data-id="element-487">
                    মোট: {formatCurrency(qty * TICKET_PRICE)}
                  </span>
                </div>
              </button>)}
          </div>
        </div>
      </main>
    </KioskScreen>;
}